var styleDataHash = "2a3c432b";
const injectCss = () => {
  var css = `.tqKjS{--wds-side-panel-content-padding-vertical:0px}[dir] .avGq1{padding-bottom:calc(var(--wds-side-panel-footer-padding-vertical, 18px)*2 + var(--wds-button-size-small, 30px))!important}.fOggF{--wds-side-panel-footer-padding-vertical:18px;bottom:0;position:absolute}[dir] .fOggF{background:var(--wds-color-fill-surface-overlay,var(--wsr-color-D80,#fff))}[dir=ltr] .fOggF,[dir=rtl] .fOggF{left:0;right:0}.hT5fm{height:100%}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var fullscreen_mobile_layout_default = {
  "content": "tqKjS",
  "contentWithFooter": "avGq1",
  "footer": "fOggF",
  "fullscreen": "hT5fm"
};
export {
  fullscreen_mobile_layout_default as default,
  injectCss
};
//# sourceMappingURL=fullscreen-mobile-layout-scss.js.map
